const Pill = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.9217 8.23996C42.0417 8.67996 21.4017 17.36 9.04166 38.24M5.20052 34.7999C5.36052 34.1199 11.1605 12.6399 38.5605 5.07993M46.4786 13.92L49.5986 25.88C51.5186 35.4399 45.9986 44.2799 33.2786 48.4399C20.5186 52.6399 8.27864 47.8 5.75864 39.24L3.27864 31.48M31.6792 40.8399C22.7192 44.3199 13.3592 42.7199 7.55924 37.4399C7.23924 37.1199 6.95924 36.7999 6.67924 36.5199L6.63924 36.4799C5.07924 34.8399 3.87924 32.9999 3.07924 30.8399C-0.720757 20.6399 5.87924 8.59994 17.8792 3.91994C26.7992 0.439942 35.7592 1.71994 41.5192 6.95994C41.4792 6.95994 41.8792 7.23994 41.8392 7.23994C42.1592 7.51994 42.5192 7.83994 42.9192 8.19994C44.4392 9.79994 45.6792 11.7199 46.4792 13.8799C50.3192 24.1199 43.6792 36.1599 31.6792 40.8399Z"
        stroke={color}
        strokeWidth="3.004"
        strokeMiterlimit="10"
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Pill;
